import React from 'react';
import Layout from '../components/layout/Layout';

function PrivacyPage() {
  return (
    <Layout>
      <section className="section-agreement">
        <div className="container">
          <h1>ПОЛИТИКА ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</h1>

          <div>
            <p>
              <span>г. Санкт-Петербург</span>
            </p>
            <p>
              <em><span>«03» июля 2025 года</span></em>
            </p>
            <p>
              <span>&#xa0;</span>
            </p>
            <h4>
              <span>1.</span><span>Общие положения</span>
            </h4>
            <p>
              <span>1.1. Политика обработки персональных данных (далее — «Политика») издана и применяется Индивидуальным предпринимателем Ермолаевой Алиной Алексеевной, ОГРНИП: 321784700059356, ИНН: 302200695506, (далее — «Оператор»), в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» (далее - Закон).</span>
            </p>
            <p>
              <span>1.2. Все вопросы, связанные с обработкой персональных данных, не урегулированные Политикой, разрешаются в соответствии с действующим законодательством Российской Федерации в области персональных данных.</span>
            </p>
            <p>
              <span>1.3. Политика:</span>
            </p>
            <p>
              <span>●</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>устанавливает правила обработки Оператором персональных данных, предоставляемых физическими лицами, вступившими в договорные и иные гражданско-правовые отношения (далее – Субъект ПД) с Оператором.</span>
            </p>
            <p>
              <span>●</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>определяет цели, правовые основания, порядок и объем обрабатываемых персональных данных;</span>
            </p>
            <p>
              <span>●</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>содержит сведения о реализуемых требованиях к защите обрабатываемых персональных данных;</span>
            </p>
            <p>
              <span>●</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>определяет порядок взаимодействия с субъектами персональных данных при поступлении от них обращений;</span>
            </p>
            <p>
              <span>●</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>способы, сроки обработки персональных данных;</span>
            </p>
            <p>
              <span>●</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>порядок уничтожения персональных данных.</span>
            </p>
            <p>
              <span>1.4. Текст Политики доступен Субъектам ПД в сети Интернет по адресу https://www.sunpanda.ru/.</span>
            </p>
            <p>
              <span>1.5. Незнание условий, установленных Политикой, не является основанием для предъявления со стороны Субъекта ПД каких-либо претензий к Оператору.</span>
            </p>
            <p>
              <span>1.6. Для обработки персональных данных, не связанных с использованием технических средств, требуется отдельное согласие.</span>
            </p>
            <p>
              <span>&#xa0;</span>
            </p>
            <h4>
              <span>2.</span><span>Термины и определения</span>
            </h4>
            <table className='table table-bordered bg-white' cellspacing="0" cellpadding="0">
              <tr>
                <td>
                  <p>
                    <span>термин</span>
                  </p>
                </td>
                <td>
                  <p>
                    <span>определение</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <em><span>Субъект ПД</span></em>
                  </p>
                </td>
                <td>
                  <p>
                    <span>физические лица, граждане Российской Федерации, иностранные граждане, предоставляющие Оператору свои персональные данные. </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <em><span>Сайт</span></em>
                  </p>
                </td>
                <td>
                  <p>
                    <span>совокупность информации, текстов, графических элементов, дизайна, изображений, фото и видеоматериалов и иных результатов интеллектуальной деятельности, а также программ для ЭВМ, содержащихся в информационной системе, обеспечивающей доступность такой информации в сети Интернет, по сетевым адресам (включая поддомены): </span><a href="https://www.sunpanda.ru/"><u><span>https://www.sunpanda.ru/</span></u></a><span> и мобильные приложения SunPanda Ахтубинск, SunPanda Новошахтинск, SunPanda Крымск, SunPanda Сарапул, SunPanda Ейск, Кафе Пунш Знаменск, Твоя Еда Знаменск, Sushi Land Знаменск, размещенных на платформах App Store и Google Play.</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <em><span>Файлы </span></em>
                  </p>
                </td>
                <td>
                  <p>
                    <span>данные, которые автоматически передаются Оператору в процессе использования Сайта с помощью установленного на устройстве Субъекта ПД программного обеспечения, в том числе IP-адрес, Cookie и другие файлы.</span>
                  </p>
                </td>
              </tr>
            </table>
            <p>
              <span>&#xa0;</span>
            </p>
            <h4>
              <span>3.</span><span>Согласие Субъекта ПД на обработку персональных данных</span>
            </h4>
            <p>
              <span>3.1. Субъект ПД принимает условия Политики и дает Оператору информированное и осознанное согласие на обработку своих персональных данных на условиях, предусмотренных Политикой и Законом:</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>При предоставлении Оператору Согласия в форме электронного документа (составленного и подписанного Субъектом ПД на бумажном носителе и направленного Оператору в порядке, предусмотренном п. 15 Политики).</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>При заполнении формы обратной связи – для персональных данных, которые Субъект ПД предоставляет Оператору при заполнении формы обратной связи в сети Интернет на Сайте и электронных сервисах (Telegram и т.д.). Субъект ПД считается предоставившим согласие на обработку своих персональных данных, внесенных в поля формы обратной связи, в момент нажатия кнопки, подтверждающей отправку заявки (кнопки могут называться “Отправить”, “Написать” и иным аналогичным образом).</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>При любом использовании Сайта – для персональных данных, которые автоматически передаются Оператору в процессе использования Сайта с помощью установленного на устройстве Субъекта ПД программного обеспечения. Субъект ПД считается предоставившим согласие на обработку своих персональных данных в момент начала использования Сайта.</span>
            </p>
            <p>
              <span>3.2. Согласие Субъекта ПД на обработку Оператором его персональных данных действует со дня, предоставления согласия на их обработку, и в течение срока, необходимого для достижения целей обработки персональных данных, если в тексте самого Согласия не установлено иное.</span>
            </p>
            <p>
              <span>3.3. Субъект ПД вправе отозвать согласие на обработку персональных данных в форме и порядке, предусмотренном в разделе 15 Политики.</span>
            </p>
            <p>
              <span>3.4. Оператор не обрабатывает персональные данные лиц, не достигших полной дееспособности. В случае, если лицо не достигло такого возраста, оно не имеет права предоставлять свои персональные данные и давать Согласие на их обработку Оператором. В случае выявления недееспособности лица, предоставившего свои персональные данные без разрешения его законного представителя, Оператор незамедлительно блокирует обработку таких персональных данных до выяснения обстоятельств.</span>
            </p>
            <p>
              <span>&#xa0;</span>
            </p>
            <h4>
              <span>4.</span><span>Условия предоставления персональных данных Субъектом ПД</span>
            </h4>
            <p>
              <span>4.1. Оператор в общем случае не проверяет достоверность персональной информации, предоставляемой Субъектами ПД, и не осуществляет контроль за их дееспособностью. Риск предоставления недостоверных персональных данных, в том числе предоставление данных третьих лиц как своих собственных при этом несет сам субъект персональных данных.</span>
            </p>
            <p>
              <span>4.2. Оператор исходит из того, что Субъект ПД предоставляет достоверную и достаточную персональную информацию по вопросам, предлагаемым в формах Сайта или путем предоставления согласия в порядке, предусмотренном п. 3.1. и поддерживает эту информацию в актуальном состоянии. </span>
            </p>
            <p>
              <span>4.3. Предоставляя согласие Субъект ПД уведомлен о праве установить запреты на передачу (кроме предоставления доступа) этих персональных данных Оператором неограниченному кругу лиц, а также запреты на обработку или условия обработки (кроме получения доступа) этих персональных данных неограниченным кругом лиц. </span>
            </p>
            <p>
              <span>&#xa0;</span>
            </p>
            <h4>
              <span>5.</span><span>Персональные данные</span>
            </h4>
            <p>
              <span>К персональным данным Субъекта ПД, обрабатываемым Оператором, относятся:</span>
            </p>
            <p>
              <span>5.1. Фамилия, имя, отчество;</span>
            </p>
            <p>
              <span>5.2. Адрес электронной почты;</span>
            </p>
            <p>
              <span>5.3. Адрес доставки, включая название населенного пункта, станции метро (если применимо), улицы (проспекта, шоссе, пр.), номер дома (включая корпус, строение, владение, прочее), номер подъезда, номер квартиры, этаж, код домофона (если применимо);</span>
            </p>
            <p>
              <span>5.4. Оператор может получать доступ, собирать и использовать в определенных Политикой целях техническую и иную информацию, связанную с Субъектами ПД, с использованием сервиса веб-аналитики. Техническая информация не является персональными данными, однако Оператор использует файлы, которые позволяют идентифицировать Субъектов ПД. Также под технической информацией понимается информация, которая автоматически передается Оператору в процессе использования Субъектом ПД Сайта с помощью установленного на устройстве Субъекта ПД программного обеспечения, а именно:</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>Данные об активности Субъекта ПД в сети Интернет, в частности о посещенных страницах, дате и времени URL-переходов и пр.;</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>Информация об устройстве и браузере, с помощью которых Субъект ПД выходил в Интернет: IP-адресе и (в случае если Субъект ПД заходит на Сайт с мобильного устройства) типе устройства и его уникальном идентификаторе;</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>Cookie-файлы, а также иные данные, собираемые посредством метрической программы.</span>
            </p>
            <p>
              <span>5.5. Оператор не осуществляет обработку:</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>биометрических персональных данных (сведения, которые характеризуют физиологические и биологические особенности человека, на основании которых можно установить его личность),</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>специальных категорий персональных данных (касающихся расовой, национальной принадлежности, политических взглядов, религиозных или философских убеждений, состояния здоровья, интимной жизни).</span>
            </p>
            <p>
              <span>5.6. Обработка персональных данных Субъекта ПД производится Оператором с использованием баз данных на территории Российской Федерации.</span>
            </p>
            <p>
              <span>5.7. Персональные данные обрабатываются с использованием автоматизированных систем.</span>
            </p>
            <h4>
              <span>6.</span><span>Правовые основания обработки персональных данных</span>
            </h4>
            <p>
              <span>Обработка персональных данных Субъекта ПД осуществляется на следующих правовых основаниях:</span>
            </p>
            <p>
              <span>6.1. Конституция РФ;</span>
            </p>
            <p>
              <span>6.2. Гражданский кодекс Российской Федерации;</span>
            </p>
            <p>
              <span>6.3. ФЗ от 29.12.2012 № 273-ФЗ «Об образовании в Российской Федерации»;</span>
            </p>
            <p>
              <span>6.4. Согласие Субъекта ПД на обработку персональных данных.</span>
            </p>
            <p>
              <span>&#xa0;</span>
            </p>
            <h4>
              <span>7.</span><span>Цели обработки персональных данных и категории Субъектов ПД</span>
            </h4>
            <table className='table table-bordered bg-white' cellspacing="0" cellpadding="0">
              <tr>
                <td>
                  <p>
                    <span>Категория </span>
                    <span>Субъекта ПД</span>
                  </p>
                </td>
                <td>
                  <p>
                    <span>Категория персональных данных </span>
                  </p>
                </td>
                <td>
                  <p>
                    <span>Цель</span>
                  </p>
                </td>
                <td>
                  <p>
                    <span>Способы обработки ПД</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <span>Пользователь/Посетитель Сайта</span>
                  </p>
                </td>
                <td>
                  <p>
                    <span>Cookie-файлы, IP-адрес, а также иные данные, собираемые посредством метрических программ.</span>
                  </p>
                </td>
                <td>
                  <p>
                    <span>Продвижение услуг на рынке</span>
                  </p>
                </td>
                <td>
                    сбор, запись,
                    систематизация, накопление,
                    хранение, уточнение (обновление, изменение),
                    извлечение, использование,
                    передача (предоставление, доступ), обезличивание,
                    блокирование, удаление, уничтожени
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <span>физическое лицо - получатель услуг, оказываемых Оператором на основании заключенного договора</span>
                  </p>
                </td>
                <td>
                  <p>
                    <span>Фамилия, имя, отчество;</span>
                  </p>
                  <p>
                    <span>Адрес электронной почты;</span>
                  </p>
                  <p>
                    <span>Адрес доставки, включая название населенного пункта, станции метро (если применимо), улицы (проспекта, шоссе, пр.), номер дома (включая корпус, строение, владение, прочее), номер подъезда, номер квартиры, этаж, код домофона (если применимо).</span>
                  </p>
                  <p>
                    <span>&#xa0;</span>
                  </p>
                </td>
                <td>
                  <p>
                    <span>Подготовка, заключение и исполнение гражданско-правового договора</span>
                  </p>
                  <p>
                    <span>&#xa0;</span>
                  </p>
                </td>
                <td>
                    сбор, запись,
                    систематизация, накопление,
                    хранение, уточнение (обновление, изменение),
                    извлечение, использование,
                    передача (предоставление, доступ), обезличивание,
                    блокирование, удаление, уничтожени
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <span>физическое лицо- подрядчик/ исполнитель Оператора </span>
                  </p>
                </td>
                <td>
                  <p>
                    <span>Фамилия, имя, отчество;</span>
                  </p>
                  <p>
                    <span>Адрес электронной почты, ИНН, ОГРН/ОГРНИП, номер расчетного счета</span>
                  </p>
                </td>
                <td>
                  <p>
                    <span>Подготовка, заключение и исполнение гражданско-правового договора</span>
                  </p>
                </td>
                <td>
                    сбор, запись,
                    систематизация, накопление,
                    хранение, уточнение (обновление, изменение),
                    извлечение, использование,
                    блокирование, удаление, уничтожени
                </td>
              </tr>
            </table>
            <p>
              <span>&#xa0;</span>
            </p>
            <p>
              <span>Субъект ПД имеет право на возражение против обработки данных. Возражение направляется Оператору Субъектом ПД в порядке п. 14.1 Политики.</span>
            </p>
            <p>
              <span>&#xa0;</span>
            </p>
            <h4>
              <span>8.</span><span>Обработка персональных данных Субъекта ПД включает совершение Оператором следующих действий: </span>
            </h4>
            <p>
              <span>8.1. сбор, </span>
            </p>
            <p>
              <span>8.2. запись, </span>
            </p>
            <p>
              <span>8.3. систематизация, </span>
            </p>
            <p>
              <span>8.4. накопление, </span>
            </p>
            <p>
              <span>8.5. хранение, </span>
            </p>
            <p>
              <span>8.6. уточнение (обновление, изменение), </span>
            </p>
            <p>
              <span>8.7. извлечение, </span>
            </p>
            <p>
              <span>8.8. использование, </span>
            </p>
            <p>
              <span>8.9. передача (предоставление, доступ), </span>
            </p>
            <p>
              <span>8.10. обезличивание, </span>
            </p>
            <p>
              <span>8.11. блокирование, </span>
            </p>
            <p>
              <span>8.12. удаление, уничтожение.</span>
            </p>
            <p>
              <span>&#xa0;</span>
            </p>
            <h4>
              <span>9.</span><span>Способы обработки ПД</span>
            </h4>
            <p>
              <span>9.1. Перечень разрешенных способов обработки персональных данных: сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передача (предоставление, доступ), обезличивание, блокирование, удаление, уничтожение. Третьему лицу запрещено осуществлять передачу и распространение персональных данных.</span>
            </p>
            <p>
              <span>9.2. Сбор персональных данных Субъекта ПД осуществляется в случаях, указанных в п. 3.1 Политики.</span>
            </p>
            <p>
              <span>9.3. Хранение персональных данных осуществляется (в зависимости от того, какое событие наступит раньше):</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>до момента их удаления Субъектом ПД в соответствующем разделе Сайта;</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>до момента их уничтожения Оператором - в случае поступления от Субъекта ПД отзыва согласия на обработку персональных данных или требования об уничтожении персональных данных;</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>до момента истечения срока действия согласия или достижения целей обработки персональных данных.</span>
            </p>
            <p>
              <span>&#xa0;</span>
            </p>
            <p>
              <span>9.4. Оператор вправе осуществлять передачу персональных данных третьим лицам. Такая передача не является распространением персональных данных Субъекта ПД неопределенному кругу лиц.</span>
            </p>
            <p>
              <span>9.5. Оператор передает персональные данные третьим лицам - заведениям, которые оказывают услуги потребителям. Оператор также вправе передавать данные сервисам аналитики.</span>
            </p>
            <p>
              <span>9.6. Цели передачи персональных данных: исполнение условий договора перед Субъектами ПД и продвижение услуг Оператора на рынке.</span>
            </p>
            <p>
              <span>9.7. Уничтожение персональных данных осуществляется Оператором в следующих случаях:</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>поступление от Субъекта ПД отзыва согласия на обработку персональных данных;</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>получение от Субъекта ПД требования об уничтожении персональных данных;</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>истечение срока действия согласия;</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>окончания срока хранения персональных данных в соответствии с договоренностями Оператора и Субъекта ПД.</span>
            </p>
            <p>
              <span>&#xa0;</span>
            </p>
            <h4>
              <span>10.</span><span>Осуществление обработки персональных данных посредством куки (Cookie)</span>
            </h4>
            <p>
              <span>10.1. Осуществление обработки персональных данных посредством куки (Cookie) представляет собой фрагмент данных, которые сервер Оператора отправляет и которые хранятся на устройстве Субъекта персональных данных. Эти данные могут включать в себя как персональные, так и обезличенные технические сведения, в зависимости от содержания файла.</span>
            </p>
            <p>
              <span>10.2. Структура, содержание и технические характеристики файлов Cookie определяются Сайтом Оператора и могут изменяться без направления предварительного уведомления пользователям Сайта. Такие файлы Cookie не позволяют Оператору получать личную информацию о пользователях Сайта.</span>
            </p>
            <p>
              <span>10.3. Оператор использует файлы Cookie для идентификации пользователей Сайта, сохранения их индивидуальных настроек и предпочтений, предоставления персонализированных услуг, целевой рекламы, а также для статистических и исследовательских целей, повышения безопасности и улучшения Сайта и сервисов в соответствии с предпочтениями пользователей.</span>
            </p>
            <p>
              <span>10.4. Оператор использует файлы Cookie для обеспечения нормального функционирования Сайта, в частности для выполнения следующих задач: технических задач, например: обеспечение регистрации и аутентификации Пользователей в личных кабинетах, организации навигации по Сайту, обеспечение защиты от угроз информационной безопасности. Сохранение файлов Cookie для этих задач является обязательным для пользователей Сайта, поскольку в ином случае его нормальное функционирование может быть нарушено. Подобные нарушения функционирования, среди прочего, могут повлечь риски информационной безопасности (к примеру, способствовать хакерским атакам на Сайт или попыткам незаконного доступа к личным кабинетам Пользователей); функциональных задач, например: формирование корзины покупок, поиск и подбор подходящих товаров, использование личных настроек интерфейса Сайта для пользователей Сайта.</span>
            </p>
            <p>
              <span>10.5. Файлы Cookie для статистических и исследовательских целей собираются только в обезличенной форме и обрабатываются в агрегированном (обобщенном) виде, т.е. статистическая информация не может быть отнесена к прямо или косвенно определенному, или определяемому физическому лицу. </span>
            </p>
            <p>
              <span>10.6. Субъект персональных данных имеет право запретить своему устройству принимать эти данные или ограничить их прием. Отказ от приема или ограничение может повлиять на функциональность некоторых элементов Сайта. Субъект персональных данных должен самостоятельно настроить свое оборудование так, чтобы оно соответствовало его предпочтениям по функциональности и уровню защиты данных Cookie.</span>
            </p>
            <p>
              <span>&#xa0;</span>
            </p>
            <h4>
              <span>11.</span><span>Меры, применяемые Оператором для защиты персональных данных</span>
            </h4>
            <p>
              <span>Оператор принимает необходимые и достаточные правовые, организационные и технические меры для защиты информации, предоставляемой Субъектами ПД, от неправомерного или случайного доступа, уничтожения, изменения, блокирования, копирования, распространения, а также от иных неправомерных действий с ней третьих лиц. Такие действия, в частности, включают: </span>
            </p>
            <p>
              <span>11.1. Назначение лица, ответственного за обработку персональных данных - Ермолаеву Алину Алексеевну;</span>
            </p>
            <p>
              <span>11.2. Применение организационных и технических мер по обеспечению безопасности персональных данных при их обработке в информационных системах;</span>
            </p>
            <p>
              <span>11.3. Контроль фактов несанкционированного доступа к персональным данным и принятие мер по недопущению подобных инцидентов в дальнейшем;</span>
            </p>
            <p>
              <span>11.4. Контроль за принимаемыми мерами по обеспечению безопасности персональных данных и уровнем защищенности информационных систем персональных данных.</span>
            </p>
            <p>
              <span>&#xa0;</span>
            </p>
            <p>
              <strong><span>12.Порядок уничтожения персональных данных</span></strong>
            </p>
            <p>
              <span>12.1. Ответственное лицо Оператора уничтожает информацию, содержащую персональные данные Субъекта ПД в соответствии с п. 9.6. Политики в срок не позднее 10 дней с даты обращения Субъекта ПД, истечения срока хранения, срока действия, достижения цели обработки персональных данных либо утраты необходимости в их достижении.</span>
            </p>
            <p>
              <span>12.2. Уничтожение происходит одним из следующих способов:</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>уничтожение носителя, на котором расположена информация, содержащая персональные данные Субъекта ПД;</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>полное форматирование информации, содержащей персональные данные Субъекта ПД;</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>полное форматирование информации, содержащей персональные данные Субъекта ПД, с использованием специальной вспомогательной программы в составе Программного обеспечения Оператора (утилита).</span>
            </p>
            <p>
              <span>12.3. Составление Акта уничтожения персональных данных Субъекта ПД. В акте указываются:</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>дата, место и время уничтожения;</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>фамилия, инициалы членов Комиссии;</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>вид и количество уничтожаемых носителей, содержащих персональные данные субъектов персональных данных (в случае если уничтожаются носители);</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>основание для уничтожения;</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>способ уничтожения.</span>
            </p>
            <p>
              <span>12.4. Факт уничтожения носителей, содержащих персональные данные Субъектов ПД, фиксируется в журнале учета документов, переданных на уничтожение. Данный документ является документом конфиденциального характера и вместе с актами хранится на электронном носителе, по месту регистрации Оператора.</span>
            </p>
            <p>
              <span>&#xa0;</span>
            </p>
            <h4>
              <span>13.</span><span>Ограничение ответственности</span>
            </h4>
            <p>
              <span>13.1. Оператор не несет ответственности за возможное нецелевое использование персональных данных и причинение какого-либо ущерба Субъекту ПД, произошедшее вследствие:</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>технических неполадок в программном обеспечении и в технических средствах и сетях, находящихся вне контроля Оператора;</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>в связи с намеренным или ненамеренным использованием Сайта не по его прямому назначению третьими лицами;</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>необеспечения конфиденциальности паролей доступа или намеренной передачи паролей доступа, иной информации с Сайта самим Субъектом ПД при получении услуг Оператора или использовании Сайта другим лицам, не имеющим доступа к данной информации;</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>неправомерных действий третьих лиц по доступу к данным Сайта, в т.ч. персональным данным.</span>
            </p>
            <p>
              <span>13.2. Оператор не несет ответственность за порядок использования Персональных данных Субъекта ПД третьими лицами, с которыми Субъект ПД взаимодействует в рамках использования Сайта.</span>
            </p>
            <p>
              <span>13.3. Оператор не осуществляет проверку наличия особого режима обработки персональных данных Субъектов ПД. Если Субъект ПД является гражданином стран Европейского союза или гражданином иных государств, временно или постоянно проживающим на территории стран ЕС и получает доступ к Сайту из стран Европы, Оператор предпринимает все разумные меры для обеспечения соблюдения таких требований законодательства о защите персональных данных. Для этого Субъект ПД обязан уведомить Оператора о наличии особого режима защиты его персональных данных путем обращения по адресу электронной почты Оператора.</span>
            </p>
            <p>
              <span>&#xa0;</span>
            </p>
            <h4>
              <span>14.</span><span>Права Субъектов ПД</span>
            </h4>
            <p>
              <span>Субъект ПД вправе:</span>
            </p>
            <p>
              <span>14.1. По своему усмотрению предоставлять Оператору персональные данные для их обработки на условиях, указанных в Политике;</span>
            </p>
            <p>
              <span>14.2. Обращаться к Оператору с требованиями, в том числе об уточнении персональных данных; о блокировке или уничтожении персональных данных, если такие данные являются неполными, устаревшими, недостоверными, незаконно полученными или не являются необходимыми для заявленной цели обработки. Требование предъявляется в порядке, предусмотренном в Разделе 14 Политики;</span>
            </p>
            <p>
              <span>14.3. На основании запроса получать от Оператора информацию, касающуюся обработки его персональных данных и предусмотренную п. 7 ст. 14 Закона от 27.07.2006 №152-ФЗ «О персональных данных».</span>
            </p>
            <p>
              <span>14.4. Отозвать согласие на обработку персональных данных в любое время ст. 9 Закона от 27.07.2006 №152-ФЗ «О персональных данных»;</span>
            </p>
            <p>
              <span>14.5. Устанавливать ограничения на распространение персональных данных ст. 10.1 Закона от 27.07.2006 №152-ФЗ «О персональных данных»;</span>
            </p>
            <p>
              <span>14.6. Защищать свои права.</span>
            </p>
            <p>
              <span>&#xa0;</span>
            </p>
            <h4>
              <span>15. Обращения Субъектов ПД</span>
            </h4>
            <p>
              <span>15.1. Субъект ПД вправе направлять Оператору свои запросы и требования (далее – Обращение), в том числе относительно использования его персональных данных, а также отзыва согласия на обработку персональных данных по форме, указанной в приложении № 1. Обращение может быть направлено следующими способами:</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>В письменной форме по адресу Оператора (Раздел 17 Политики);</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>В форме электронного документа (скан-, фотокопия документа). Документ должен быть направлен с адреса электронной почты Субъекта ПД, указанного им при регистрации на Сайте или в договоре в качестве уполномоченного адреса электронной почты, по адресу электронной почты Оператора.</span>
            </p>
            <p>
              <span>15.2. Направляемое Субъектом ПД Обращение, должно содержать следующую информацию:</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>Фамилию и имя Субъекта ПД;</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>Сведения, подтверждающие участие Субъекта ПД в отношениях с Оператором;</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>Суть Обращения;</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>Подпись Субъекта ПД или его законного представителя.</span>
            </p>
            <p>
              <span>15.3. Оператор рассматривает Обращение Субъекта ПД в следующем порядке:</span>
            </p>
            <p>
              <span>●</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>Обращение регистрируется в Журнале учета Обращений Субъектов ПД; </span>
            </p>
            <p>
              <span>●</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>Проверяется наличие всех обязательных реквизитов Обращения;</span>
            </p>
            <p>
              <span>●</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>Проверяется обоснованность Обращения;</span>
            </p>
            <p>
              <span>●</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>Предоставляется ответ на Обращение. В зависимости от сути Обращения ответ на него должен содержать:</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>запрашиваемую Субъектом ПД информацию об обрабатываемых персональных данных;</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>мотивированный отказ в предоставлении запрашиваемой информации об обрабатываемых персональных данных;</span>
            </p>
            <p>
              <span>-</span><span>&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>уведомление о действиях, совершаемых с персональными данными Субъекта ПД по его Обращению.</span>
            </p>
            <p>
              <span>15.4. Ответ на Обращение направляется в течении 10 (десяти) дней с даты получения Оператором Обращения в форме, соответствующей форме Обращения Субъекта ПД, если о предоставлении Ответа на Обращение в иной форме не указано в Обращении. (п. 15.1 Политики).</span>
            </p>
            <p>
              <span>&#xa0;</span>
            </p>
            <h4>
              <span>16. Изменение Политики</span>
            </h4>
            <p>
              <span>16.1. Оператор оставляет за собой право вносить изменения в Политику. На Субъекте ПД лежит обязанность при каждом использовании Сайта знакомиться с текстом Политики.</span>
            </p>
            <p>
              <span>16.2. Новая редакция Политики вступает в силу с момента ее размещения в соответствующем разделе сайта Оператора. Продолжение пользования Сайтом или его сервисами после публикации новой редакции Политики означает принятие Политики и ее условий Субъектом ПД. В случае несогласия с условиями Политики Субъект ПД должен незамедлительно прекратить использование Сайта.</span>
            </p>
            <p>
              <span>16.3. В случае внесения изменений в Политику, Оператор уведомляет об этом путем размещения новой редакции Политики на сайте. Такое уведомление будет считаться надлежащим.</span>
            </p>
            <p>
              <span>&#xa0;</span>
            </p>
            <h4>
              <span>17. Реквизиты Оператора и ответственный за обработку персональных данных:</span>
            </h4>
            <p>
              <span>Индивидуальный предприниматель Ермолаева Алина Алексеевна</span>
            </p>
            <p>
              <span>ОГРНИП: 321784700059356 ИНН: 302200695506</span>
            </p>
            <p>
              <span>Адрес электронной почты: </span><a href="mailto:admin@sunpanda.ru"><u><span>admin@sunpanda.ru</span></u></a>
            </p>
            <p>
              <span>Ответственный за обработку персональных данных — Ермолаева Алина Алексеевна</span>
            </p>
            <p>
              <span>&#xa0;</span>
            </p>
          </div>
          <br />
          <div>
            <p>
              <span>&#xa0;</span>
            </p>
            <p>
              <strong><span>Кому:</span></strong><span> ИП ___</span>
            </p>
            <p>
              <span>ИНН: _____ / ОГРНИП: _____</span>
            </p>
            <p>
              <span>&#xa0;</span>
            </p>
            <p>
              <strong><span>От:</span></strong><span> _____</span>
            </p>
            <p>
              <span>Адрес электронной почты: _____</span>
            </p>
            <p>
              <span>Телефон: _____</span>
            </p>
            <p>
              <span>&#xa0;</span>
            </p>
            <p>
              <strong><span>&#xa0;</span></strong>
            </p>
            <p>
              <strong><span>Отзыв согласия на обработку персональных данных </span></strong>
            </p>
            <p>
              <span>-форма-</span>
            </p>
            <p>
              <span>&#xa0;</span>
            </p>
            <p>
              <span>«__» _____ 202_ года мной, [ФИО], было предоставлено ИП ___ согласие на обработку персональных данных посредством [согласия c обработкой cookie/оформления заказа на сайте c доменным именем </span><a href="https://www.sunpanda.ru"><u><span>https://www.sunpanda.ru</span></u></a><span> / другим способом].</span>
            </p>
            <p>
              <span>Руководствуясь ч. 2 ст. 9 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных», заявляю предоставленного ранее согласия на обработку персональных данных.</span>
            </p>
            <p>
              <span>Я уведомлен, что в случае согласия оператор вправе продолжить обработку персональных данных без согласия субъекта персональных данных при наличии оснований, указанных в п. п. 2 - 11 ч. 1 ст. 6, ч. 2 ст. 10 и ч. 2 ст. 11 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных».</span>
            </p>
            <p>
              <span>&#xa0;</span>
            </p>
            <table cellspacing="0" cellpadding="0">
              <tr>
                <td>
                  <p>
                    <span>Субъект персональных данных</span>
                  </p>
                </td>
                <td>
                  <p>
                    <span>_____________/ФИО</span>
                  </p>
                </td>
              </tr>
            </table>
            <p>
              <span>&#xa0;</span>
            </p>
            <p>
              <span>&#xa0;</span>
            </p>
          </div>

        </div>
      </section>
    </Layout>
  );
}

export default PrivacyPage;
